import { mergeMap, startWith, concatMap, map, catchError } from 'rxjs/operators';
import { from, concat } from 'rxjs';
import { ofType } from 'redux-observable';
import { setLoader, handleErrors, createToast, setError } from './deps';
import { CONCESSIONS_COMBO_ON_SERVER, CONCESSIONS_ON_SERVER, CONCESSIONS_REMOVE, CONCESSIONS_REQUEST_CATEGORY, CONCESSIONS_REQUEST_COMBO, CONCESSIONS_REQUEST_COMBO_ITEM, CONCESSIONS_REQUEST_ITEM, PICKUP_NUMBER_REQUEST } from './types';
import { setpickUpNumber, setConcessionCombo, setConcessionComboItem, setConcessionComboOnServer, setConcessionItem, setConcessionOnServer, successConcessionCategories } from './actions';
import { setOrder } from '../order/actions';





export function fetchConcessionCategory($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_REQUEST_CATEGORY),
    mergeMap(action => {
      const { cinemaId } = action.payload;

      return from($apiConcessions.fetchAllCategories(cinemaId)).pipe(
        concatMap(res => [successConcessionCategories(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export function fetchConcessionItem($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_REQUEST_ITEM),
    mergeMap(action => {
      const { cinemaId, id } = action.payload;

      return from($apiConcessions.fetchConcessionById(cinemaId, id)).pipe(
        concatMap(res => [setConcessionItem(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export function fetchConcessionCombo($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_REQUEST_COMBO),
    mergeMap(action => {
      const { cinemaId, id } = action.payload;

      return from($apiConcessions.fetchComboConcessionById(cinemaId, id)).pipe(
        concatMap(res => [setConcessionCombo(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export function fetchConcessionComboItem($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_REQUEST_COMBO_ITEM),
    mergeMap(action => {
      const { cinemaId, id } = action.payload;
      return from($apiConcessions.fetchComboItemConcessionById(cinemaId, id)).pipe(
        concatMap(res => [setConcessionComboItem(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export function fetchConcessionOnServer($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_ON_SERVER),
    mergeMap(action => {
      const { orderId, data } = action.payload;

      return from($apiConcessions.orderConcessionItem(orderId, data)).pipe(
        concatMap(res => [setConcessionOnServer(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export function fetchConcessionComboOnServer($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_COMBO_ON_SERVER),
    mergeMap(action => {
      const { orderId, concessionsData, data } = action.payload;

      return from($apiConcessions.orderConcessionCombo(orderId, concessionsData, data)).pipe(
        concatMap(res => [setConcessionComboOnServer(res), setOrder(res?.order), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}


export function removeConcession($action, $state, { api }) {
  const $apiConcessions = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(CONCESSIONS_REMOVE),
    mergeMap(action => {
      const { orderId } = action.payload;

      return from($apiConcessions.removeConcessionItem(orderId)).pipe(
        concatMap(res => [setConcessionOnServer(res), setLoader(false)]),

        ...handleErrors(action),
        catchError(err => [setError(err.code, err.message, err), setLoader(false)]),

        startWith(setLoader(true))
      )
    })
  );
}

export const fetchPickUpNumber = ($action, $state, { api }) => {
  const $api = api.getModuleByName('concessions');

  return $action.pipe(
    ofType(PICKUP_NUMBER_REQUEST),
    mergeMap(action => {
      const { cinemaId, bookingNumber, pickup } = action.payload;

      return from($api.fetchPickNumber(cinemaId, bookingNumber, pickup)).pipe(
        concatMap(res => [setpickUpNumber(res), setLoader(false)]),

        ...handleErrors(action),

        catchError(err =>
          concat([
            createToast('warning', err.message),
            setpickUpNumber(false),
            setLoader(false)
          ])
        ),

        startWith(setLoader(true))
      );
    })
  );
};
